import { createContext, useEffect, useState, useMemo } from 'react';
import type { Dispatch, ReactNode, SetStateAction } from 'react';
import type { ConsumerResponse } from './consumer.schema';
import { useSession } from 'lib/auth/auth.hooks';
import { setUserId, track } from 'lib/sdks/analytics';

type ConsumerContextValue = {
  email?: string;
  profile: ConsumerResponse | null;
};

export const ConsumerContext = createContext<
  [ConsumerContextValue, Dispatch<SetStateAction<ConsumerContextValue>>] | null
>(null);

export const ConsumerProvider = ({ children }: { children: ReactNode }) => {
  const consumerContextValue = useState<ConsumerContextValue>({
    profile: null,
  });
  const { status, data } = useSession();

  const userId = useMemo(() => data?.user.id ?? null, [data?.user.id]);

  useEffect(() => {
    status !== 'loading' && setUserId(userId);
  }, [status, userId]);

  useEffect(() => {
    if (userId && status === 'authenticated') {
      track('consumer_area.login');
    }
  }, [userId, status]);

  return (
    <ConsumerContext.Provider value={consumerContextValue}>
      {children}
    </ConsumerContext.Provider>
  );
};
